import React, { Component } from 'react';

const getWindowSizes = () => {
  return {
    height: window.innerHeight,
    width: window.innerWidth,
  };
};

const windowWatcher = WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = getWindowSizes();
    }

    componentDidMount() {
      window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }

    onResize = () => this.setState(getWindowSizes());

    render() {
      const { height, width } = this.state;

      return <WrappedComponent windowWidth={width} windowHeight={height} {...this.props} />;
    }
  };
};

export default windowWatcher;



// WEBPACK FOOTER //
// ../ui-components/hocs/window-watcher.jsx